import { GET, POST } from 'src/network/apiHandler';
import config from 'src/globals';
import {
    UPDATE_USER_PREFERENCE,
    GET_NOTIFICATION_AUTH_TOKEN,
    FCM_TOKEN_UPDATE,
} from 'src/api/routes';

const { API_BASE_URL } = config;

export const updateUserNotificationPreference = async (params) => {
    return POST(`${API_BASE_URL}${UPDATE_USER_PREFERENCE}`, params);
};

export const getNotificationAuthToken = async () => {
    return GET(`${API_BASE_URL}${GET_NOTIFICATION_AUTH_TOKEN}`);
};

export const updateFcmToken = async (params) => {
    return POST(`${API_BASE_URL}${FCM_TOKEN_UPDATE}`, params);
};
